import { render } from "./AppCardConnections.vue?vue&type=template&id=10987406&scoped=true"
import script from "./AppCardConnections.vue?vue&type=script&lang=js"
export * from "./AppCardConnections.vue?vue&type=script&lang=js"

import "./AppCardConnections.vue?vue&type=style&index=0&id=10987406&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10987406"]])

export default __exports__